var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('router-link',{attrs:{"to":{
      name: _vm.$routerNames.EDIT,
      params: Object.assign({}, _vm.account.params,
        _vm.$route.params),
    }}},[_c('Icon',{attrs:{"name":"settings-outline","fill":_vm.$scss.colors.secondaryTextBg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }